import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyValueStepTranslations = wrapTranslationsSchema({
	name: 'BuyEasyValueStepTranslations',
	title: 'Value Step Translations',
	sanityId: 'buyeasy-wizardValueStep',
	fields: {
		question: 'What is the estimated value of your purchase?',
		applicabilityQuestion: 'Does your purchase cover any of the following?',
		applicabilityOptionYes: 'Yes, at least one of them',
		applicabilityOptionNo: 'None of the above',
		applicabilityNoQuestions: 'The amount you chose is not allowed for this country and category',
	},
});
